
import { api } from "./api";

export const ExpenseCategoryList = async (addUrl = '') => {
  let url = `hostel/expense?${addUrl}`
  return await api.get(url);
};

export const ExpenseCreate = async (data) => {
  return await api.post('hostel/expense/post',data);
};

export const ExpenseDelete = async (id) => {
  return await api.get(`hostel/expense/delete?id=${id}`);
};

export const ExpenseUpdate = async (data) => {
  return await api.post('hostel/expense/update',data);
};

export const ExpenseTransactionList = async (addUrl = '') => {
  let url = `hostel/expense/transactions?${addUrl}`
  return await api.get(url);
};

export const ExpenseTransactionCreate = async (data) => {
  return await api.post('hostel/expense/transaction/post',data);
};

export const ExpenseTransactionUpdate = async (data) => {
  return await api.post('hostel/expense/transaction/update',data);
}; 

export const ExpenseTransactionDelete = async (id) => {
  return await api.get(`hostel/expense/transaction/delete?id=${id}`);
};
